"use client";

import React from "react";
import {
    Users,
    Award,
    Handshake,
    MapPin,
    Briefcase,
    Settings,
    GraduationCap,
    TrendingUp,
} from "lucide-react";
import ImpactCard from "./Impactcard";

const MedhaviImpactpage = () => {
    const impactData1 = [
        {
            icon: Settings,
            value: "18+",
            label: "Sectors",
        },
        {
            icon: Users,
            value: "500000+",
            label: "Candidates Trained",
        },
        {
            icon: Handshake,
            value: "20+",
            label: "CSR Partners",
        },
        {
            icon: MapPin,
            value: "74000+",
            label: "Candidates trained in the North East states",
        },
        {
            icon: Award,
            value: "105+",
            label: "Differently abled youth trained & placed",
        },
        {
            icon: TrendingUp,
            value: "70%",
            label: "Placed in 20+ States",
        },
        {
            icon: Briefcase,
            value: "300+",
            label: "Industry Partners",
        },
        {
            icon: GraduationCap,
            value: "30000+",
            label: "Apprentices Enabled",
        },
    ];

    return (
        <div className="mt-10 grid md:grid-cols-4 grid-cols-2 gap-6 xl:gap-8 w-full">
            {impactData1.map((item, index) => (
                <ImpactCard
                    key={index}
                    icon={item.icon}
                    value={item.value}
                    label={item.label}
                    delay={index * 0.08}
                />
            ))}
        </div>
    );
};

export default MedhaviImpactpage;
